import React from 'react';
import { Select } from '@economic/taco';
import useCachedQuery from '../../hooks/useCachedQuery';
import { AccountTypeNumber } from '../../../../types';

export default function AccountTypeDropdown({ includeAllTypesButSumAlpha, ...props }) {
    const query = useCachedQuery('/accounts/types', []);

    const data = query.data
        .filter(
            accountType =>
                accountType &&
                ((includeAllTypesButSumAlpha && accountType.number !== AccountTypeNumber.SumAlpha) ||
                    accountType.number === AccountTypeNumber.ProfitAndLoss ||
                    accountType.number === AccountTypeNumber.Balance)
        )
        .map(accountType => ({
            data: accountType,
            text: accountType.name,
            value: accountType.number,
        }));

    return <Select {...props} data={data} loading={query.loading} />;
}
